import { AppConfig } from '@/constants/AppConfig';
import { Routes } from '@/constants/Routes';
import { TranslationExplorer } from '@/pages/Admin/TranslationExplorer/TranslationExplorer';
import { UXSandbox } from '@/pages/UXSandbox/UXSandbox';
import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

enum PageTabs {
  SandboxTab = 'uxSandbox',
  TranslationTab = 'translationExplorer',
}

export const UXTestingPage = () => {
  const { componentName } = useParams();
  const navigate = useNavigate();
  const initialTab = (componentName ?? '') in PageTabs
    ? componentName as PageTabs
    : PageTabs.TranslationTab;
  const [tab, setTab] = useState(initialTab);

  const shouldShowUxSandbox = (AppConfig.env.local || AppConfig.env.devel);

  const onTabChanged = (_: unknown, value: PageTabs) => {
    setTab(value);
    navigate(`${Routes.UX_TESTING}/${value}`);
  };

  const tabSelector = <Box sx={{ borderBottom: 1, borderColor: 'divider', px: 4 }}>
    <Tabs onChange={onTabChanged} value={tab}>
      <Tab label="Translation Explorer" value={PageTabs.TranslationTab} />
      <Tab label="UX Sandbox" value={PageTabs.SandboxTab} />
    </Tabs>
  </Box>;

  return (
    <>
      {shouldShowUxSandbox && tabSelector}
      {
        shouldShowUxSandbox
        && tab === PageTabs.SandboxTab
        && <UXSandbox basePath={Routes.UX_TESTING}/>
      }
      {tab === PageTabs.TranslationTab && <TranslationExplorer/>}
    </>
  );
};
